module.exports = __webpack_public_path__ + "assets/1cc710ebc5b26dd89c3c9b69e6d4da91.jpg";